import axios from "../../interceptors/axiosInterceptor";
import {
  FETCH_CUSTOMER_ZONE_URL,
  FETCH_STORE_CONFIG,
  GET_CUSTOMERS_V2_URL,
  GET_MULTIPLE_USERS_DETAIL_V2_URL,
  GET_STORE_DETAIL_URL,
  GET_USER_BY_PHONE_NUMBER_V2_URL,
  GET_USER_DETAIL_V2_URL,
  STORE_TYPE,
  UPDATE_USER_PASSWORD,
} from "../../config/Url";
import {
  IAgentTitle,
  ICustomerConfigResponse,
  IGetCustomerNewDetailResponse,
  IGetQueryParams,
  IGetZoneParams,
  INewCustomerResponseObject,
  IUpdatePassword,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import {
  normalizeCustomerConfigResponse,
  normalizeFetchCustomerResponse,
  normalizeStoreType,
} from "../../normalizer/CustomerNormalizer";
import { normalizeCatchErrors } from "../../utils/errorUtils";

export const fetchCustomerApiCall = (queryParam: IGetQueryParams = {}) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_CUSTOMERS_V2_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 50
              ? true
              : false;
          resolve(
            normalizeFetchCustomerResponse(data, pageNumber, isPaginatedRes)
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getCustomerDetailsNewApiCall = (id: string) =>
  new Promise<IGetCustomerNewDetailResponse>((resolve, reject) => {
    let url = GET_USER_DETAIL_V2_URL.replace("{user_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getBulkCustomerDetailsByIdApiCall = (payload: string[]) =>
  new Promise<Record<string, IGetCustomerNewDetailResponse>>(
    (resolve, reject) => {
      let url = GET_MULTIPLE_USERS_DETAIL_V2_URL;
      axios
        .post(url, payload, getAuthOptions())
        .then((response) => {
          if (response?.data) {
            resolve(response.data);
          }
        })
        .catch((error) => {
          const errorPayload = normalizeCatchErrors(error.response);
          reject(errorPayload);
        });
    }
  );

export const getCustomerZoneApiCall = (queryParam: IGetZoneParams = {}) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    const customerType =
      (queryParam.customerType as any)?.value || queryParam.customerType;
    requestConfig.params = Object.assign({}, queryParam, { customerType });
    axios
      .get(FETCH_CUSTOMER_ZONE_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getStoreDetailApiCall = (id: string) =>
  new Promise<INewCustomerResponseObject>((resolve, reject) => {
    let url = GET_STORE_DETAIL_URL.replace("{store_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getUserByPhoneNumberApiCall = (phoneNumber: string) =>
  new Promise<IGetCustomerNewDetailResponse>((resolve, reject) => {
    let url = GET_USER_BY_PHONE_NUMBER_V2_URL.replace(
      "{phone_number}",
      phoneNumber
    );
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          let data = response.data;
          data.nationalId = data.nationalId || "";
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchStoreTypeApiCall = () =>
  new Promise<Array<IAgentTitle>>((resolve, reject) => {
    axios
      .get(STORE_TYPE, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(normalizeStoreType(data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchStoreConfigApiCall = () =>
  new Promise<ICustomerConfigResponse>((resolve, reject) => {
    axios
      .get(FETCH_STORE_CONFIG, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve(normalizeCustomerConfigResponse(response && response.data));
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => reject(normalizeCatchErrors(error.response)));
  });

export const updateUserPasswordApiCall = (
  userId: string,
  payload: IUpdatePassword
) => {
  return new Promise<void>((resolve, reject) => {
    let url = UPDATE_USER_PASSWORD.replace("{userId}", userId);
    axios
      .post(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};
